import React from "react";
import { useLanguage } from "../../../../contexts";
import { ASPECT_COLOR, mixHex } from "./visualColors";

// "Ruta": una línea de tiempo horizontal por aspecto, con un punto por
// objetivo en la posición de su año meta. Puerto de renderRuta() del mockup
// de referencia — pos()/clamp() son funciones puras internas, portadas tal
// cual (escala comprimida entre 3% y 94% para que nada quede recortado).
export function RouteVisual({ groups, baseYear, horizonEnd, siteName }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  if (!groups.length) return null;

  const pos = (y) => 3 + ((y - baseYear) / (horizonEnd - baseYear)) * 91;
  const clamp = (p) => (p >= 86 ? "translateX(calc(-100% + 10px))" : p <= 8 ? "translateX(-10px)" : "translateX(-50%)");
  const years = Array.from({ length: horizonEnd - baseYear + 1 }, (_, i) => baseYear + i);

  return (
    <div style={{ maxWidth: 840, margin: "6px auto 30px" }}>
      {groups.map(({ aspect, objetivos }) => {
        const color = ASPECT_COLOR[aspect] || "#5E89B4";
        return (
          <div key={aspect} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
            <div style={{ width: 92, textAlign: "right", fontFamily: "'Sora',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: 1, color }}>
              {t(aspect).toUpperCase()}
            </div>
            <div style={{ flex: 1, position: "relative", height: 64 }}>
              <div style={{ position: "absolute", left: `${pos(baseYear)}%`, right: `${(100 - pos(horizonEnd)).toFixed(1)}%`, top: 29, height: 3, background: mixHex(color, 0.7), borderRadius: 2 }} />
              {objetivos.map((o, k) => {
                const p = pos(o.year);
                const arriba = k % 2 === 0;
                return (
                  <React.Fragment key={o._id}>
                    <div style={{ position: "absolute", left: `${p.toFixed(1)}%`, top: arriba ? 2 : 44, transform: clamp(p), whiteSpace: "nowrap", fontSize: 10, color: "#1A3562" }}>
                      <strong style={{ color }}>−{o.reductionTons}%</strong> {o.source} · {o.year}
                    </div>
                    <div style={{ position: "absolute", left: `${p.toFixed(1)}%`, top: 24, width: 13, height: 13, borderRadius: "50%", background: color, border: "3px solid #fff", boxShadow: `0 0 0 1.5px ${color}`, transform: "translateX(-50%)" }} />
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        );
      })}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 92 }} />
        <div style={{ flex: 1, position: "relative", height: 26, borderTop: "2px solid #1A3562" }}>
          {years.map((y, i) => (
            <span key={y} style={{ position: "absolute", left: `${pos(y).toFixed(1)}%`, transform: "translateX(-50%)", top: 5, fontSize: 10.5, color: i === 0 || y === horizonEnd ? "#1A3562" : "#6B7A8E", fontWeight: i === 0 || y === horizonEnd ? 700 : 400 }}>
              {y}
            </span>
          ))}
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: 12, fontFamily: "'Sora',sans-serif", fontWeight: 700, letterSpacing: 2, fontSize: 12, color: "#1A3562" }}>
        {t("pd_wheel_plan_label")} {baseYear}–{horizonEnd} · {(siteName || "").toUpperCase()}
      </div>
    </div>
  );
}
